import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { Input, InputPropsT } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/form/input.scss';

export type NcInputPropsT = InputPropsT;

export type NcInputT = React.FC<NcInputPropsT>;

export const NcInput: NcInputT = ({
  className,
  ...props
}) => {
  const cssClasses = mergeClassNameStrings('nc-input', className);

  return (
    <Input
      className={cssClasses}
      {...props}
    />
  );
};
